import { useQuery } from '@tanstack/react-query'
import { activityLogsApi } from '../api/activityLogsApi'

export const activityLogsKeys = {
  all: ['activity-logs'],
  lists: () => [...activityLogsKeys.all, 'list'],
  list: (filters) => [...activityLogsKeys.lists(), filters],
  details: () => [...activityLogsKeys.all, 'detail'],
  detail: (id) => [...activityLogsKeys.details(), id],
}

export function useActivityLogs(params = {}) {
  return useQuery({
    queryKey: activityLogsKeys.list(params),
    queryFn: () => activityLogsApi.getActivityLogs(params),
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  })
}

export function useActivityLog(id, enabled = true) {
  return useQuery({
    queryKey: activityLogsKeys.detail(id),
    queryFn: () => activityLogsApi.getActivityLog(id),
    enabled: Boolean(id) && enabled,
  })
}
